import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Sophos } from "@graylog/enterprise-api";
import FormWrap from "../common/FormWrap";
import formValidation from "../common/utils/formValidation";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b;
    setLoading(true);
    Sophos.checkCredentials({
      sophos_client_id: ((_a = formData == null ? void 0 : formData.sophosClientId) == null ? void 0 : _a.value) || "",
      sophos_client_secret: ((_b = formData == null ? void 0 : formData.sophosClientSecret) == null ? void 0 : _b.value) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("sophos.authorize.connection_error")
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: t("sophos.authorize.connection_error")
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["sophosName", "sophosClientId", "sophosClientSecret"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "sophosName",
        type: "text",
        fieldData: formData.sophosName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "sophosClientId",
        type: "text",
        onChange,
        fieldData: formData.sophosClientId,
        label: t("sophos.authorize.client_id"),
        help: t("sophos.authorize.client_id_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "sophosClientSecret",
        type: "password",
        onChange,
        fieldData: formData.sophosSecret,
        label: t("sophos.authorize.client_secret"),
        help: t("sophos.authorize.client_secret_help"),
        required: true
      }
    )
  );
};
export default StepAuthorize;
